
export default {
	profile: {},
	contacts: {},
	contactIds: [],
	currentContact: null,
}